import React from 'react';

const DetailsList = props => {
    const {
        columns
    } = props

    let className = 'details-list'

    if(columns.length == 1){
        className += ' single-column'
    }

    return (
        <div className={className}>
            { columns.map((column, index) => {
                return (
                    <ul key={index}>
                        { column.map((row, rowIndex) => {
                            return (
                                <li key={rowIndex}>
                                    <label>
                                        { row.label }:
                                    </label>
                                    <span className={!row.value ? 'empty' : null}>
                                        { row.value ? row.value : `(No ${row.emptyString})` }
                                    </span>
                                </li>
                            )
                        })}
                    </ul>
                )
            })}
        </div>
    )
};

export default DetailsList;
